
import React from "react";
import { Tabs } from 'antd';
import { ApisTab } from "./AllTabContent";
const BlockChainApitab = ()=>{
  return (
    <div className="tab-section">
     <div className="container">
      <div className="tabs">
      <Tabs 
      defaultActiveKey="1"    
      items={ApisTab}
    />
      </div>
     </div>
    </div>
  )
}
export default BlockChainApitab;